<template>
  <v-window touchless :value="slider">
    <h-hint
      v-for="category in categories"
      :key="category.id"
      :choice="category.isMultipleChoice"
      :min="MenuChoice.min(category)"
      :max="MenuChoice.max(category)"
    />
  </v-window>
</template>

<script>
  import MenuChoice from '@/Models/Static/MenuChoice'
  import HHint from './HintsItem'

  export default {
    components: {
      HHint,
    },

    data: () => ({
      MenuChoice,
    }),

    computed: {
      slider () {
        return this.$store.state.orders.menu.category
      },
      categories () {
        return this.$store.state.orders.menu.categories
      },
    },
  }
</script>
